import * as yup from "yup";

export const UIFormValidationSchema = yup.object().shape({
  survey: yup.object().required("Survey is required"),

  tasks: yup
    .array()
    .of(
      yup.object().shape({
        booth: yup.object().required("Booth is required"),
        phone: yup.object().required("Phone is required"),
        sample_size: yup
          .number()
          .typeError("Sample size must be a number")
          .required("Sample size is required")
          .positive("Sample size must be positive"),
      })
    )
    .min(1, "At least one task is required"),
});

export const CMDFormValidationSchema = yup.object().shape({
  commands: yup.string().required("Commands are required"),
});
